import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token (fallback for browsers/iframes that block SameSite=None cookies)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  const roleSession = sessionStorage.getItem("roleSession");
  if (roleSession) config.headers["X-Role-Session"] = roleSession;
  return config;
});

api.interceptors.response.use((response) => response, (error) => {
  if (error.response?.status === 409 && error.response?.data?.detail?.code === "role_session_invalid") {
    sessionStorage.removeItem("roleSession");
    sessionStorage.setItem("roleViewEnded", "1");
    window.location.assign("/");
  }
  return Promise.reject(error);
});

export function formatApiError(detail) {
  if (detail == null) return "Er ging iets mis. Probeer het opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string") return detail.message;
    if (typeof detail.msg === "string") return detail.msg;
  }
  return String(detail);
}

export default api;
